import { useState, useEffect } from "react";
import { ErrorContext } from "../../../utils/context/error";
import { setuploadimage } from "../../../services/archivos";
import PropTypes from 'prop-types';
import Modal from "../../modal";
import Dropzone from "./dropzone";
function FormModal({ show, ArchivoI, Tag, handleshow, fillUploadImagen}) 
{
   const [descripcion, setDescripcion]= useState("");
   const [files, setFile]= useState("");
   const [habilita, setHabilita] = useState(false);
   const [validar, setValidar] = useState(false);
   const [ArchivoId, setArchivoId] = useState(0);
   const { setShowToast, setOpciones } = ErrorContext();
   
   //----------------------------------------------------
   const handleInicio = () =>
    {
      setDescripcion("");
      setFile("");
      setArchivoId(ArchivoI)
    }
   //----------------------------------------------------
   const handleAceptar = async() =>
    {
      setHabilita(true);
      setShowToast(false);
      const response = await setuploadimage(  
          files,
          descripcion,
          ArchivoId,
          Tag,
          'IM'
        );
        console.log(response)
        if (response) 
          {
            if (response.status === 200) 
              {
                handleshow(false);
                fillUploadImagen();
              } 
            else 
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
            }
          }
        else
          {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
          }  
        setHabilita(false);
    }
   
   //----------------------------------------------------
   const handleCancel = () =>
    {
      handleshow(false);
    }
  //-----------------------------------------------------
  const handleFileSelected = (file) => 
    {
      setFile(file);
    };  
  
  //-----------------------------------------------------
  useEffect(() => 
    {
     if (show)
      console.log(ArchivoI)
      handleInicio()
    }, [show]);
    
    return (
        <>
         <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Cargue de Archivo'}>
            <div className="flex lg:w-[26rem]">
                <form noValidate className="flex flex-col w-full">
                    <div className="flex flex-col w-full h-full ">
                      <div className="w-full">
                          <label>Seleccionar Imagen</label>
                          <Dropzone onFileSelected={handleFileSelected}></Dropzone>
                      </div>    
                      <div className="w-full mt-4">
                         <label>Descripción</label>
                          <textarea name='searchid' value={descripcion || ""} placeholder="Descripción" 
                                    onChange={(e)=> setDescripcion(e.target.value)}
                                    autoComplete="off" 
                                    disabled={Tag === 2}>
                            </textarea>
                      </div>
                      
                      <div className="flex w-full gap-4 mt-6 justify-end">
                         <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                         <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
                      </div>
                    </div>  
                </form>
            </div>           
         </Modal>              
        </>
      );
}

FormModal.propTypes = {
  show: PropTypes.bool.isRequired,
  ArchivoI: PropTypes.number.isRequired, 
  Tag: PropTypes.number.isRequired,
  handleshow: PropTypes.func.isRequired,
  fillUploadImagen: PropTypes.func.isRequired,
};

export default FormModal;